import React from 'react';

import OrgUnitContextProvider from '@usas/ui-web/state/orgUnit/OrgUnitContextProvider';

const AppStateContextProviders = ({ children }) => {
  return (
    <OrgUnitContextProvider>
      {children}
    </OrgUnitContextProvider>
  );
};
export default AppStateContextProviders;